export const onServiceWorkerUpdateReady = () => {
    console.log(`This application has been updated. Trying to reload...`)
    window.location.reload(true)
}